<script setup>
const route = useRoute();
const { $get } = useAxios();

const { data: video, pending: isLoaded } = await useAsyncData(
  `get video by id ${route.params.id}`,
  () => $get(`/api/v3/videos/${route.params.id}`)
);

const url = computed(() => {
  if (video.value) {
    if (video.value?.link.includes("watch")) {
      return video.value?.link.split("=")[1];
    } else {
      return video.value?.link.split("youtu.be/")[1];
    }
  }
  return false;
});

useHead(
  computed(() => {
    if (video.value) {
      return {
        title: `${video.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
        meta: [
          {
            hid: "title",
            property: "title",
            content: `${video.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
          },
          {
            hid: "og:title",
            property: "og:title",
            content: `${video.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
          },
          {
            hid: "url",
            name: "url",
            content: `https://rusdram.org${route.fullPath}`,
          },
          {
            hid: "og:url",
            property: "og:url",
            content: `https://rusdram.org${route.fullPath}`,
          },
          {
            hid: "image",
            name: "image",
            content: `${video.value?.photo}/-/quality/smart/image.png`,
          },
          {
            name: "og:image",
            property: "og:image",
            content: `${video.value?.photo}/-/quality/smart/image.png`,
          },
        ],
      };
    } else {
      return {
        title: "Русдрам",
      };
    }
  })
);
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <div class="container px-4 xl:px-0">
        <RBack></RBack>
      </div>
      <r-section :title="video.name" class="mt-5" v-if="video">
        <iframe
          :src="`https://www.youtube.com/embed/${url}`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="w-full"
          style="aspect-ratio: 16/9"
        />
      </r-section>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
